import React, { Suspense, useContext, useRef } from "react";
import { Detailed, PivotControls, useGLTF } from "@react-three/drei";
import * as THREE from "three";
import { ThreeContext } from "./Context";

export default function Mercedes(props) {

  const { nodes, materials } = useGLTF("./Models/Voitures/Mercedes.glb");
  const { Glass, Metal, BlackMetal, BlackPlastic, RedLight, YellowMetal } = useContext(ThreeContext);
  const {debug} = useContext(ThreeContext);

  return (
    <PivotControls  anchor={[0, 0, 0]} activeAxes={[debug, debug, debug]} visible={debug} depthTest={false}>
        <group {...props} dispose={null}>

            <mesh geometry={nodes.Desirefx_me_rims025_12.geometry}  material={YellowMetal}/>     
            <mesh geometry={nodes.Desirefx_me_rims025_19.geometry}  material={YellowMetal}/>      
            
            <mesh geometry={nodes.Desirefx_me_rims025_2.geometry}  material={Glass}/>        
            <mesh geometry={nodes.Desirefx_me_rims025_14.geometry}  material={Glass}/>
            <mesh geometry={nodes.Desirefx_me_rims025_5.geometry}  material={Glass}/>

            <mesh geometry={nodes.Desirefx_me_rims025.geometry}  material={BlackMetal} castShadow/>
            <mesh geometry={nodes.Desirefx_me_rims025_4.geometry}  material={BlackMetal} castShadow/>        
            <mesh geometry={nodes.Desirefx_me_rims025_6.geometry}  material={BlackMetal} castShadow/>
            <mesh geometry={nodes.Desirefx_me_rims025_7.geometry}  material={BlackMetal} castShadow/>        
            <mesh geometry={nodes.Desirefx_me_rims025_11.geometry}  material={BlackMetal} castShadow/>

            <mesh geometry={nodes.Desirefx_me_rims025_9.geometry}  material={BlackPlastic} castShadow/>
            <mesh geometry={nodes.Desirefx_me_rims025_10.geometry}  material={BlackPlastic} />
            <mesh geometry={nodes.Desirefx_me_rims025_3.geometry}  material={BlackPlastic} castShadow/>               
            <mesh geometry={nodes.Desirefx_me_rims025_15.geometry}  material={BlackPlastic}/>
            <mesh geometry={nodes.Desirefx_me_rims025_16.geometry}  material={BlackPlastic}/>
            <mesh geometry={nodes.Desirefx_me_rims025_17.geometry}  material={BlackPlastic}/>

            <mesh geometry={nodes.Desirefx_me_rims025_18.geometry}  material={RedLight}/>         
            <mesh geometry={nodes.Desirefx_me_rims025_22.geometry}  material={RedLight}/>

            <mesh geometry={nodes.Desirefx_me_rims025_21.geometry}  material={Metal}/>
            <mesh geometry={nodes.Desirefx_me_rims025_23.geometry}  material={Metal}/>
            <mesh geometry={nodes.Desirefx_me_rims025_24.geometry}  material={Metal}/> 
            <mesh geometry={nodes.Desirefx_me_rims025_25.geometry}  material={Metal}/>
            <mesh geometry={nodes.Desirefx_me_rims025_1.geometry}  material={Metal}/>
        </group>
    </PivotControls>
  );
}

useGLTF.preload("./Models/Voitures/Mercedes.glb");

{/* 
<mesh geometry={nodes.Desirefx_me_rims025_20.geometry}  material={materials.mat}/> 
<mesh geometry={nodes.Desirefx_me_rims025_13.geometry}  material={materials["headlight.001"]}/>
 <mesh geometry={nodes.Desirefx_me_rims025_8.geometry}  material={materials["headlight.002"]}/>      
*/}
